import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  image, 
  url, 
  type = 'website',
  publishedTime,
  author,
  section,
  keywords
}) => {
  const siteName = 'Cerveja Delivery';
  const defaultImage = 'https://cerveja.delivery/og-image-default.jpg'; // Substitua por uma imagem padrão real
  const currentUrl = url || window.location.href;
  const metaDescription = description || 'O maior hub de cervejarias artesanais do Brasil. Delivery e Menu Digital.';
  const metaImage = image || defaultImage;
  const metaTitle = title ? `${title} | ${siteName}` : siteName;

  // Schema.org structure for Blog Posts
  const structuredData = type === 'article' ? {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "headline": title,
    "image": [metaImage],
    "datePublished": publishedTime,
    "dateModified": publishedTime,
    "author": [{
      "@type": "Person",
      "name": author || "Equipe Cerveja Delivery"
    }],
    "publisher": {
      "@type": "Organization",
      "name": siteName,
      "logo": {
        "@type": "ImageObject",
        "url": "https://cerveja.delivery/logo.png"
      }
    },
    "description": metaDescription
  } : {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": siteName,
    "url": "https://cerveja.delivery",
    "description": metaDescription
  };

  return (
    <Helmet>
      {/* Standard Metadata */}
      <title>{metaTitle}</title>
      <meta name="description" content={metaDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={currentUrl} />

      {/* Open Graph / Facebook / WhatsApp */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={metaImage} />
      <meta property="og:site_name" content={siteName} />
      {publishedTime && <meta property="article:published_time" content={publishedTime} />}
      {section && <meta property="article:section" content={section} />}

      {/* Twitter Cards */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={metaTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={metaImage} />

      {/* Structured Data (JSON-LD) */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default SEO;